import { render, staticRenderFns } from "./PlayerSearch.vue?vue&type=template&id=3525b2ca&scoped=true&"
import script from "./PlayerSearch.vue?vue&type=script&lang=js&"
export * from "./PlayerSearch.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSearch.vue?vue&type=style&index=0&id=3525b2ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525b2ca",
  null
  
)

export default component.exports